import React from 'react';
import classNames from 'classnames';
import styles from './Stars.module.scss';
const MAX_RATING = 5;
const ALL_STARS = [1, 2, 3, 4, 5];
/* `index` is 1..5, matching the rating scale. */
const toStarState = (rating, index) => {
    if (index <= rating) {
        return 'full';
    }
    if (index - rating < 1) {
        const partial = index - rating;
        return partial < 0.25 ? 'full' : partial > 0.75 ? 'empty' : 'half';
    }
    return 'empty';
};
/**
 * Read-only star rating display. Drop-in replacement for `GenericStars` from
 * `@wix/ftsystem`, ported for the same reason the `wix-ui-tpa` primitives in this directory
 * were: ftsystem is built by yoshi, whose webpack treats every `.scss` as a CSS module.
 * Bundlers that only apply that to `*.module.scss` (vite, and so every non-yoshi consumer)
 * fail to build against it. Porting it removes the last such dependency from this package.
 *
 * ftsystem exposed a factory (`GenericStars({ Icon, gap })` returning a component); this
 * takes `icon` and `gap` as ordinary props instead, since a factory bought nothing at the
 * single call site.
 */
export const Stars = ({ className, rating, a11yLabel, icon: Icon, gap = 'small', collapsed = false, 'data-hook': dataHook, }) => {
    const normalizedRating = Math.min(Math.max(rating, 0), MAX_RATING);
    return (React.createElement("div", { className: classNames(styles.root, gap === 'small' ? styles.smallGap : styles.largeGap, className), "data-hook": dataHook, "data-value": normalizedRating },
        a11yLabel ? React.createElement("span", { className: styles.a11yLabel }, a11yLabel) : null,
        React.createElement("div", { "aria-hidden": "true", className: styles.innerContainer }, (collapsed ? [1] : ALL_STARS).map((index) => {
            switch (toStarState(normalizedRating, index)) {
                case 'full':
                    return React.createElement(Icon, { key: index, className: styles.full });
                case 'empty':
                    return React.createElement(Icon, { key: index, className: styles.empty });
                case 'half':
                    return (React.createElement("div", { className: styles.halfStarWrapper, key: index },
                        React.createElement(Icon, { key: "start", className: classNames(styles.halfStarInnerWrapperStart, styles.full) }),
                        React.createElement(Icon, { key: "end", className: classNames(styles.halfStarInnerWrapperEnd, styles.empty) })));
            }
        }))));
};
//# sourceMappingURL=Stars.js.map